import { getRoot, types } from 'mobx-state-tree'
import { DateString, RootModel } from '@shared/data-access'

export const MODEL_NAME = 'ConversationRoom'

export const Model = RootModel.named(MODEL_NAME)
  .props({
    id: types.identifier,
    sid: types.maybeNull(types.string),
    name: types.maybeNull(types.string),
    contentObject: types.maybeNull(types.frozen({})),
    lastUpdatedAt: types.maybeNull(DateString),
    personPolicyId: types.maybeNull(types.string),
  })
  .volatile((self) => ({
    _store: getRoot(self)[`${MODEL_NAME}Store`],
  }))
